(function () {
  function submitDrawerFilters(event) {
    const button = event.target.closest('.collection-grid--erd .mobile-facets__footer .button--primary');
    if (!button) return;

    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form || typeof FacetFiltersForm === 'undefined') return;

    event.preventDefault();
    event.stopPropagation();

    const searchParams = FacetFiltersForm.createSearchParams(form);
    FacetFiltersForm.renderPage(searchParams, event);
  }

  function closeDrawerOnOverlayClick(event) {
    const overlay = event.target.closest('.collection-grid--erd .mobile-facets');
    if (!overlay) return;
    if (event.target.closest('.mobile-facets__inner, .mobile-facets__submenu')) return;

    const menuDrawer = overlay.closest('menu-drawer');
    const disclosure = menuDrawer?.querySelector('.mobile-facets__disclosure');
    if (!disclosure?.classList.contains('menu-opening')) return;

    const summary = menuDrawer.querySelector('summary');
    if (!summary || typeof menuDrawer.closeMenuDrawer !== 'function') return;

    event.preventDefault();
    menuDrawer.closeMenuDrawer(event, summary);
  }

  function closeDrawerOnCloseClick(event) {
    const closeButton = event.target.closest('.collection-grid--erd .mobile-facets__close');
    if (!closeButton) return;

    const menuDrawer = closeButton.closest('menu-drawer');
    const disclosure = menuDrawer?.querySelector('.mobile-facets__disclosure');
    if (!disclosure?.classList.contains('menu-opening')) return;

    const summary = menuDrawer.querySelector('summary');
    if (!summary || typeof menuDrawer.closeMenuDrawer !== 'function') return;

    event.preventDefault();
    event.stopPropagation();
    menuDrawer.closeMenuDrawer(event, summary);
  }

  document.addEventListener('click', submitDrawerFilters, true);
  document.addEventListener('click', closeDrawerOnCloseClick, true);
  document.addEventListener('click', closeDrawerOnOverlayClick);
})();
